<script>
export default {
    name: "CancelBookingModal",

    props: {
        showModal: Boolean,
    }
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/4 sm:w-11/12">
        <template v-slot:title>
          <h5 class="font-bold text-base">Cancel Booking</h5>
        </template>
        <template v-slot:modal-body>
          <div class="flex flex-wrap -m-4">
              <div class="w-full p-tiny">
                  <label for="grid-memo" class="label-control">Memo:</label>
                  <textarea id="grid-memo" cols="30" rows="3" class="input-control input-sm text-xs"></textarea>
              </div>
          </div>
        </template>
        <template v-slot:modal-footer>
          <button class="btn-danger btn-sm text-xs mr-4" @click="$emit('closeModal')"><i class="fa fa-times"></i> Close</button>
          <button class="btn-primary btn-sm text-xs"><i class="fa fa-save"></i> Cancel Booking</button>
        </template>
    </tail-modal>
</template>
